const mime = new Map([
  ['image/png', 'png'],
  ['image/jpg', 'jpg'],
  ['image/jpeg', 'jpeg'],
]);

async function addValue(formData: FormData, key: string, value: any) {
  if (typeof value === 'object') {
    await Object.keys(value).reduce(async (accu, k) => {
      await accu;
      await addValue(formData, key + '[' + k + ']', value[k]);
    }, Promise.resolve());
  } else if (Array.isArray(value)) {
    await value.reduce(async (accu, k) => {
      await accu;
      await addValue(formData, key + '[' + k + ']', value[k]);
    }, Promise.resolve());
  } else {
    let filename = undefined;
    let v = value;
    if (typeof value === 'string' && value.startsWith('blob:')) {
      const response = await fetch(value);
      v = await response.blob();
      if (!mime.has(v.type)) {
        return Promise.reject();
      }
      filename =
        key.replace('[', '_').replace(']', '') + '.' + mime.get(v.type);
    } else if (typeof value === 'string' && value.includes('base64')) {
      v = dataURIToBlob(value);
      if (!mime.has(v.type)) {
        return Promise.reject();
      }
      filename =
        key.replace('[', '_').replace(']', '') + '.' + mime.get(v.type);
    }

    if (filename) {
      formData.append(key, v, filename);
    } else {
      formData.append(key, v);
    }
  }
}

export async function getFormData(
  object: Record<string, any>
): Promise<FormData> {
  const formData = new FormData();
  await Object.keys(object).reduce(async (accu, key) => {
    await accu;
    await addValue(formData, key, object[key]);
  }, Promise.resolve());

  return formData;
}

function dataURIToBlob(dataURI: string) {
  const splitDataURI = dataURI.split(',');
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
}
